module.exports = __webpack_public_path__ + "img/die-1.5126892d.svg";